class ContentCarousel extends HTMLElement {
  constructor() {
    super();

    const viewportNode = this.querySelector(".carousel__viewport");

    // get options from data attributes
    const loop = this.dataset.loop === "true";
    const slidesToScroll = this.dataset.slidesToScroll || 1;
    const startIndex = this.dataset.startIndex || 0;
    const draggable = this.dataset.draggable === "true";
    const SlideAutoPlay = this.dataset.autoPlay === "true";
    const align = this.dataset.align || "start";

    const autoplayInterval = this.dataset.speed * 1000 || 3000;

    let autoplay = EmblaCarouselAutoplay(
      {
        delay: autoplayInterval,
        stopOnInteraction: false,
        playOnInit: SlideAutoPlay,
      },
      (emblaRoot) => emblaRoot.parentElement
    );

    const options = {
      active: true,
      breakpoints: {
        "(min-width: 720px)": { active: false },
      },
      loop: loop,
      slidesToScroll: slidesToScroll,
      draggable: draggable,
      startIndex: parseInt(startIndex),
      align: align,
      containScroll: "trimSnaps",
    };
    const carousel = EmblaCarousel(viewportNode, options, [autoplay]);

    const setupPrevNextBtns = (prevBtn, nextBtn, embla, autoplay) => {
      const scrollNext = () => {
        autoplay.reset();
        embla.scrollNext();
      };
      const scrollPrev = () => {
        autoplay.reset();
        embla.scrollPrev();
      };
      prevBtn.addEventListener("click", scrollPrev, false);
      nextBtn.addEventListener("click", scrollNext, false);
    };

    const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
      return () => {
        if (embla.canScrollPrev()) prevBtn.style.opacity = "1";
        else prevBtn.style.opacity = "0";

        if (embla.canScrollNext()) nextBtn.style.opacity = "1";
        else nextBtn.style.opacity = "0";
      };
    };

    // Grab button nodes
    const prevButtonNode = this.querySelector(".carousel__button--prev");
    const nextButtonNode = this.querySelector(".carousel__button--next");

    const disablePrevAndNextBtns = disablePrevNextBtns(
      prevButtonNode,
      nextButtonNode,
      carousel
    );

    setupPrevNextBtns(prevButtonNode, nextButtonNode, carousel, autoplay);

    // Add click listeners
    carousel.on("select", disablePrevAndNextBtns);
    carousel.on("init", disablePrevAndNextBtns);

    // DOT NAVIGATION
    const dots = this.querySelector(".carousel__dots");

    const setupDotBtns = (dotsArray, embla) => {
      dotsArray.forEach((dotNode, i) => {
        dotNode.addEventListener("click", () => embla.scrollTo(i), false);
      });
    };

    const generateDotBtns = (dots, embla) => {
      const template = this.querySelector("#embla-dot-template").innerHTML;
      dots.innerHTML = embla
        .scrollSnapList()
        .reduce((acc) => acc + template, "");

      return [].slice.call(dots.querySelectorAll(".carousel__dot"));
    };

    let dotsArray = generateDotBtns(dots, carousel);

    const selectDotBtn = (dotsArray, embla) => () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      dotsArray[previous].classList.remove("is-selected");
      dotsArray[selected].classList.add("is-selected");
    };
    const setSelectedDotBtn = selectDotBtn(dotsArray, carousel);

    if (dots) {
      setupDotBtns(dotsArray, carousel);
      carousel.on("select", setSelectedDotBtn);
      carousel.on("init", setSelectedDotBtn);
    }
  }
}

customElements.define("content-carousel", ContentCarousel);
